fx.ns("desktop.common.photoimport", class UploadProgress extends fx.components.ScreenPopup {
    
	constructor(model)
	{
		super(model);
        this.effect = "fade";
        this.showClose = true;
        this.service = fx.service("MediasUploader");

        this._lastPosition = 0;
    }
    
	create()
	{
		super.create();

        let mainBox = new fx.components.Box();

        /*let box = new fx.components.Box("cloud");
        let image = new fx.components.Image(fx.get("assets").cloudImage);
        this.progressText = new fx.components.Text();
        box.addChild(image, {width : 140, height : 96, top : "center", left : "center"});
        box.addChild(this.progressText, {width : 100, height : 40, top : 36, left : 20});*/

        

        let title = new fx.components.Text({text : fx.text("Nous avons bientôt fini de récupérer vos photos"), className : "title"});
        this.progressBar = new fx.components.ProgressBar({showLabel:false});
        let subtext = new fx.components.Text({text : fx.text("On s’occupe de vous rediriger quand c’est terminé"), className : "text"});

        //mainBox.addChild(box, {width : 140, height : 96, top : 0, left : "center"});
        mainBox.addChild(title, {width:"100%", top : 0, left : "center"});
        mainBox.addChild(subtext, {width:"100%", top : 50, left : "center"});
        mainBox.addChild(this.progressBar, {width:"100%", height:50, top : 100, left : 0});
        
        this.addChild(mainBox, {top:"center", left : 0, width:"100%", height:200});

		/*this.exitButton = new fx.components.IconButton( {icon: fx.get("assets").ExitIcon} );
		this.addChild(this.exitButton, {right:10, top:10, width:50, height:50});*/

    }
    
    onReady()
    {
        //this.on("click",this.onBack, this.exitButton);
        this.on("ESCAPE-DOWN", this.onBack, fx.keyboard);

        this._updateProgress();
    }

	/*onBack()
	{
        this.data.event("back");
	}*/

    onDataEvent(event)
    {
        super.onDataEvent(event);
        
        if ( event.type == "upload-finished" && !fx.service("GoogleService").progressing)
            this._lastPosition = 0;

        if (event.type == "upload-file-progress" || event.type == "upload-file" || event.type == "upload-finished")
            this._updateProgress();
            
    }

    onClose()
    {
        if (fx.get("mode") == "created-ia")
        {
            this._popup = new shared.popups.ConfirmLeaveWithoutSaving();
            this.popup(this._popup);
            this.on("confirmed", this._onConfirmed, this._popup);
        }    
        else
        {
            this.data.event("upload-progress-closed");
            super.onClose();
        }
            
    }
    
    _onConfirmed()
    {    
        this.data.event("navigate-exit");
    }

    _updateProgress()
    {
        let position = 0, total = 100;
        if (fx.service("GoogleService").progressing && fx.service("GoogleService").total > 0)
        {
            position = Math.min(50, fx.service("GoogleService").position == 0 ? 0 : (fx.service("GoogleService").position / fx.service("GoogleService").total * 100));
        }
        else 
        if ( this.service.total > 0)
        {
           position = this.service.position == 0 ? 0  : (this.service.position / this.service.total * 100);
        }

        if (position > this._lastPosition)
        {
            this.progressBar.update(position, 100);
            this._lastPosition = position;
        }
        
    }

   
});